import { render } from "./default.vue?vue&type=template&id=f6dbafbe&scoped=true"
const script = {}

import "./default.vue?vue&type=style&index=0&id=f6dbafbe&scoped=true&lang=scss"

import exportComponent from "/var/www/vhosts/klever-front3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6dbafbe"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout});
